import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function FunnelLayout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-kin-black text-kin-ivory selection:bg-kin-gold selection:text-kin-black">
      {/* Minimal Navigation specifically for funnels (reduced distractions) */}
      <header className="absolute top-0 w-full z-50 py-8 text-center">
        <Link to="/" className="text-2xl font-serif tracking-widest text-kin-ivory hover:text-kin-gold transition-colors">
          KIN.
        </Link>
      </header>
      
      <main className="flex-grow flex flex-col fade-in pt-24">
        {children}
      </main>
      
      {/* Minimal Footer for funnels */}
      <footer className="py-8 text-center text-xs text-kin-ivory/40 tracking-wider">
        <p>© {new Date().getFullYear()} Kingdom Inspira Nova Studio.</p>
      </footer>
    </div>
  );
}